import { ReactNode } from "react";

interface FieldDisplayProps {
    label: string;
    value: string | number | ReactNode;
    icon?: ReactNode;
    className?: string;
}

export const FieldDisplay = ({ label, value, icon, className = '' }: FieldDisplayProps) => {
    return (
        <div className={`flex items-center ${className}`}>
            {icon && <div className="mr-2">{icon}</div>}
            <div>
                <div className="text-sm text-slate-500">{label}</div>
                <div className="text-lg font-semibold text-slate-900">{value}</div>
            </div>
        </div>
    );
};